module.exports = __webpack_public_path__ + "static/media/chef-cook-food-33614.22349f34.png";